import type { TranslationKey } from './useTranslation';

/** The `t` this module composes over — `useTranslation().t`, or a fake in tests. */
export type Translate = (key: TranslationKey, params?: Record<string, string | number>) => string;

/**
 * Pick the singular or plural form of a message.
 *
 * The dictionaries carry one string per key and `t` knows nothing about
 * counts, so "`{{count}} item(s)`" was the house style — and a screen that
 * says "1 item(s)" reads as unfinished. This is the whole plural mechanism:
 * a pair of keys (`…One` / `…Other`) chosen on `count === 1`, with `count`
 * interpolated into whichever wins. Two forms cover every language this app
 * ships (en/de/es/fr all pluralize on exactly "one vs. everything else");
 * a language with more forms would grow this signature, not a per-call-site
 * ternary.
 */
export function plural(
  t: Translate,
  count: number,
  keys: { one: TranslationKey; other: TranslationKey },
  params?: Record<string, string | number>
): string {
  return t(count === 1 ? keys.one : keys.other, { ...params, count });
}
